import React, { useState,useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategories,
  createCategoryRequest,
  deleteCategory,
  fetchSkills,
  deleteSkill,
  saveSkill
} from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from 'sweetalert2';
import useButtonAccess from "components/Common/useButtonAccess";
import Loader from "common/pageLoader";

const SetupSkills = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { skillsList, loading, success, error } = useSelector((state) => state.SkillMasterReducer || {});
  const [authDetails, setAuthDetails] = useState(null);

  // useEffect(() => {
  //   if (loading) {
  //     dispatch(fetchCategories(authDetails?.unit_id));
  //   }
  // }, [loading, authDetails]);
  
  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchSkills(unitId));
  }, [dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (success) {
      dispatch(fetchSkills(authDetails?.unit_id));
      setIsEdit(false);
      setEditId(null);
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const competencyOptions = [
    { id: 1, name: "Technical skills" },
    { id: 2, name: "Business skills" },
    { id: 3, name: "Leadership skills" },
    { id: 4, name: "People skills" }
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      skill_id: 0,
      competency: "",
      skill: "",
      description: ""
    },
   validationSchema: Yup.object({
      competency: Yup.string().required("Competency is required"),
      skill: Yup.string().required("Skill is required"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("skill_name", values.skill);
      formData.append("description", values.description);
      formData.append("skill_id", values.skill_id);
      formData.append("com_id", values.competency);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(saveSkill(formData));
    },
  });
  

  const handleEdit = (row) => {
    formik.setValues({
      skill_id:row.skill_id,
      competency: row.com_id || "",
      skill: row.skill_name,
      description: row.description
    });
    setIsEdit(true);
    setEditId(row.skill_id);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  const columns = useMemo(() => {

    const actionColumn = (canEdit || canDelete)
      ? {
          Header: "Action",
          className: "status-col",
          applyHeaderClass: true,
          Cell: (cellProps) => {
            const { id } = cellProps.row.original; 
            return (
              <div className="d-flex gap-3">

                {canEdit && (
                  <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                  >
                    <i
                      className="bx bxs-edit font-size-18"
                      id={`edit-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`edit-tooltip-${id}`}
                    >
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                )}

                {canDelete && (
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => handleToggleStatus(cellProps.row.original)}
                  >
                    <i
                      className="mdi mdi-delete font-size-18"
                      id={`delete-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`delete-tooltip-${id}`}
                    >
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                )}

              </div>
            );
          },
        }
      : null;

    return [
      ...(actionColumn ? [actionColumn] : []),
      {
        Header: "S.No",
        Cell: ({ row }) => skillsList.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Code", accessor: "skill_code"},
      { Header: "Competency", accessor: "competency" },
      { Header: "Name", accessor: "skill_name" },
      { Header: "Description", accessor: "description" },
      { Header: "Created At", accessor: "created_dt" },
      { Header: "Created By", accessor: "created_by" },
      
    ];

  }, [skillsList, canEdit, canDelete]);


  const handleToggleStatus = (row) => {
      Swal.fire({
        title: 'Are you sure?',
        html: `You are about to delete ${row.skill_name} skill`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: false,
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
            const formData = new FormData();
            formData.append("skill_id", row.skill_id);
            formData.append("createdby", authDetails?.user_id);
            dispatch(deleteSkill(formData));
        }    
      });
    };  

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <Loader loading={loading}/> */}
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Skills" />

          {/* Input Section */}
          {(canCreate || canEdit) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  <Col md="3" lg="3" xl="3">
                    <FormGroup>
                      <Label for="competency">
                        Competency <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="competency"
                        name="competency"
                        type="select"
                        value={formik.values.competency}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.competency &&
                          Boolean(formik.errors.competency)
                        }
                      >
                        <option value="" disabled hidden>Select...</option>
                        {competencyOptions.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </Input>
                      {formik.touched.competency && formik.errors.competency && (
                        <div className="text-danger">{formik.errors.competency}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="3" lg="3" xl="3">
                    <FormGroup>
                      <Label for="skill">
                        Skill <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="skill"
                        name="skill"
                        type="text"
                        value={formik.values.skill}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.skill &&
                          Boolean(formik.errors.skill)
                        }
                      />
                      {formik.touched.skill && formik.errors.skill && (
                        <div className="text-danger">{formik.errors.skill}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="3" lg="3" xl="3">
                    <FormGroup>
                      <Label for="description">
                        Description <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="description"
                        name="description"
                        type="text"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.description &&
                          Boolean(formik.errors.description)
                        }
                      />
                      {formik.touched.description && formik.errors.description && (
                        <div className="text-danger">{formik.errors.description}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="3" lg="3" xl="3" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" color="secondary" onClick={handleCancel} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>

                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={skillsList && skillsList?.length > 0 ? skillsList : []}
                isGlobalFilter={true}
                customPageSize={10}
                // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SetupSkills;
